import React, { useEffect } from "react";
import useAuthStore from "@/store/useAuthStore";
import { Navigate } from "react-router";
import NewBadgeModal from "@/components/Modals/NewBadgeModal";
import RecommendAppModal from "@/components/Modals/RecommendAppModal";
import SubmissionReviewModal from "@/components/Modals/SubmissionReviewModal";
import NewRegisterModal from "@/components/Modals/NewRegisterModal";
import useGlobalStore from "@/store/useGlobalStore";

const PrivateRouteWrapper = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isAuthenticating = useAuthStore((state) => state.isAuthenticating);
  const persistedPathname = useAuthStore((state) => state.persistedPathname);
  const clearPersistedPath = useAuthStore((state) => state.clearPersistedPath);
  const initGlobalStore = useGlobalStore((state) => state.initGlobalStore);

  useEffect(() => {
    if (isAuthenticated) {
      initGlobalStore();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated && !isAuthenticating) {
    return <Navigate to="/signin" />;
  }

  if (isAuthenticated && persistedPathname) {
    // handles pushing to the persisted path & clearing it //
    const path = persistedPathname;
    clearPersistedPath();
    return <Navigate to={path} />;
  }

  return (
    <>
      {children}
      <NewBadgeModal />
      <RecommendAppModal />
      <SubmissionReviewModal />
      <NewRegisterModal />
    </>
  );
};

export default PrivateRouteWrapper;
